// npm install inputmask --save
import 'inputmask/dist/inputmask/inputmask.numeric.extensions.js';
import Inputmask from 'inputmask/dist/inputmask/inputmask.js';

export function modalCreate(title, body, modalClass, large = false, windowAttrs, onlyHtml = false) {
  windowAttrs = '';
  large = '';

  if (windowAttrs) {
    windowAttrs = ' ' + windowAttrs;
  }

  if (large) {
    large = ' modal-lg';
  }

  let modalWindow = `
   <div class="modal-dialog ${modalClass} ${large}">
            <div class="modal-content ${windowAttrs}">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title">
                        ${title}
                    </h4>
                </div>
                <div class="modal-body">
                    <div>
                        ${body}
                    </div>
                </div>
            </div>
            </div>
`;

  if (onlyHtml) {
    return modalWindow;
  }

  $('#main-modal').html(modalWindow).modal('show');
}

export function phoneNumberFormat(phone) {
  if (phone) {
    return '+{}'.format(keepOnlyNumbers(phone));
  }
  return '';
}

export function keepOnlyNumbers(str) {
  return Number(str.replace(/\D+/g, ""));
}

// agr like in Drupal
export function arg(position) {
  let pathname = window.location.pathname;
  let pathArray = pathname.split('/');
  return pathArray[position];
}


export function setInputMask(input, query = '.mobilephone-input-mask') {
  if (input == 'mobilephone') {
    let mask = "+7(999)999-99-99";
    let im = new Inputmask(mask);
    im.mask(document.querySelectorAll(query));
    $(query).keydown(function (e) {
      let key = e.which;
      if ((key == "37") || (key == "38") || (key == "39") || (key == "40")) {
        e.preventDefault();
      }
    });
  }
  else if (input == 'onlyNumbers') {
    let mask = "9{1,50}[X{0,1}9{0,2}]";
    let im = new Inputmask(mask, {
      definitions: {
        "X": {
          validator: "[\.]",
        }
      }
    });
    im.mask(document.querySelectorAll(query));
  }
  else if (input == 'email') {
    let im = new Inputmask({
      mask: "*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}[.*{2,6}][.*{1,2}]",
      greedy: false,
      onBeforePaste: function (pastedValue, opts) {
        pastedValue = pastedValue.toLowerCase();
        return pastedValue.replace("mailto:", "");
      },
      definitions: {
        '*': {
          validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~\-]",
          cardinality: 1,
          casing: "lower"
        }
      }
    });
    im.mask(document.getElementsByClassName("email-input-mask"));
    $('.email-input-mask').keydown(function (e) {
      let key = e.which;
      if ((key == "37") || (key == "38") || (key == "39") || (key == "40")) {
        e.preventDefault();
      }
    });
  }
}

// get query parameters from url address
export function getQueryParameterByName(name, url) {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, "\\$&");
  let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

// check if str is number
export function isNumber(s) {
  return !isNaN(+s) && isFinite(s);
}

export function redirectToPage(url) {
  if (!url) {
    url = '/';
  }
  window.location.href = url;
}

//set cookies
export function setCookie(name, value, options) {
  options = options || {};

  let expires = options.expires;
  if (!options.hasOwnProperty('path')) {
    options.path = '/';
  }

  if (typeof expires == "number" && expires) {
    let d = new Date();
    d.setTime(d.getTime() + expires * 1000);
    expires = options.expires = d;
  }
  if (expires && expires.toUTCString) {
    options.expires = expires.toUTCString();
  }

  value = encodeURIComponent(value);

  let updatedCookie = name + "=" + value;

  for (let propName in options) {
    updatedCookie += "; " + propName;
    let propValue = options[propName];
    if (propValue !== true) {
      updatedCookie += "=" + propValue;
    }
  }

  document.cookie = updatedCookie;
}

// возвращает cookie с именем name, если есть, если нет, то undefined
export function getCookie(name) {
  let matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function blink(element) {
  element.addClass('blinking');
  setTimeout(function () {
    element.removeClass('blinking');
  }, 200);
}

// return integer value
export function moneyFormat(value) {
  if (!value || value === '') {
    value = 0;
  }
  value = parseFloat(value).toFixed(0);

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// return previous array element, if first - return last
export function getPreviousElement(length, currentElement) {
  let lastElement = length - 1;
  let pervElement = currentElement - 1;

  if (pervElement < 0) {
    pervElement = lastElement;
  }

  return pervElement;
}

// return next array element, if last - return first
export function getNextElement(length, currentElement) {
  let lastElement = length - 1;
  let nextElement = currentElement + 1;

  if (nextElement > lastElement) {
    nextElement = 0;
  }

  return nextElement;
}

// send ajax request and blink element
export function ajaxUpdate(url, data, blinkElement) {
  axios.post(url, data).then(_ => blink(blinkElement));
}

// generate random string
export function stringGenerate(length = 10, onlyNumbers = false) {
  let text = '';
  let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  if (onlyNumbers) {
    possible = '0123456789'
  }

  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}

// groupBy array by key
export function groupBy(xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}

// return key by value
export function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value);
}

export function getDateTime() {
  let d = new Date();
  d = new Date(d.getTime() - 3000000);
  let date_format_str = d.getFullYear().toString() + "-" + ((d.getMonth() + 1).toString().length == 2 ? (d.getMonth() + 1).toString() : "0" + (d.getMonth() + 1).toString()) + "-" + (d.getDate().toString().length == 2 ? d.getDate().toString() : "0" + d.getDate().toString()) + " " + (d.getHours().toString().length == 2 ? d.getHours().toString() : "0" + d.getHours().toString()) + ":" + ((parseInt(d.getMinutes() / 5) * 5).toString().length == 2 ? (parseInt(d.getMinutes() / 5) * 5).toString() : "0" + (parseInt(d.getMinutes() / 5) * 5).toString()) + ":00";

  return date_format_str;
}

export function clearStringForUrl(string) {
  return string.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ' ').toLowerCase();
}

export function isJSON(str) {
  try {
    return (JSON.parse(str) && !!str);
  } catch (e) {
    return false;
  }
}